import { config } from '../config'
import { IResponse } from '../types/response.type'
import { AuthEndpoints } from '../types/endpoint.type'
import { IUser } from '../../shared/types/api/user.type'
import axios from 'axios'

export const getUserByEmail = async (token: string): Promise<IResponse<IUser>> => {
  try {
    const data = await axios.post(
      `${config.baseUrl}/${AuthEndpoints.GET}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return data.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
